import { useState, useEffect } from 'react'
import { rotulo } from '../components/functions'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import moment from 'moment'
import api from './api'

const StatusValidacaoSecao = (props) => {


    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()

    

    const desafio = props.desafio
    const nomeDesafio = props.nomeDesafio
    const formulario_id = props.formulario_id
    const secao = props.secao
    const ano = props.ano
    const secaoCampo = props.secaoCampo
    const totalPendencias = props.totalPendencias

    const [rotuloSecao, setRotuloSecao] = useState('')
    const [dataHoraUltimaAuditoria, setDataHoraUltimaAuditoria] = useState('')
    const [nomeUltimaAuditoria, setNomeUltimaAuditoria] = useState('')

    const verificaStatusSecao = () => {

        //console.log('verifica')

        if (secaoCampo && formulario_id) {


            var dataPost = {

                desafio: desafio,
                formulario_id: formulario_id,
                secaoCampo: secaoCampo,
            }

            //console.log(dataPost)
            

            api.post('statusSecao', dataPost).then((result) => {

                //console.log(result.data, 'aqui dados status seção')

                setRotuloSecao(rotulo(result.data[0].statusSecao))
                setNomeUltimaAuditoria(result.data[0].nomeUltimaAuditoria ?? '')
                setDataHoraUltimaAuditoria(result.data[0].dataHoraUltimaAuditoria)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }



    const alteraStatusSecao = (novoStatus) => {


        var dataPost = {

            desafio: desafio,
            formulario_id: formulario_id,
            secaoCampo: secaoCampo,
            novoStatus: novoStatus,
            nome: sessionStorage.getItem('nome'),
            us_codigo: sessionStorage.getItem('us_codigo'),
        }


        api.put('statusSecao', dataPost).then((result) => {

            window.toastr.success('Status da Seção alterado com sucesso!')
            setVerificaDesafio(moment().format('YYYY-MM-DD HH:mm:ss'))
            
            

        }).catch((err) => {

            console.log(err.response)

        })

    }



    useEffect(() => {

        setNomeUltimaAuditoria('')
        setDataHoraUltimaAuditoria('')

        verificaStatusSecao()

    }, [verificaDesafio])


    useEffect(() => {

        setNomeUltimaAuditoria('')
        setDataHoraUltimaAuditoria('')

        verificaStatusSecao()

    }, [formulario_id, secaoCampo])


    return (

        <div>


            
            <div className="row" style={{ display: formulario_id ? 'block' : 'none'}}>

                <div className="col-md-6">
                    
                    <br/><br/>
                    {nomeDesafio} - {secao}: {totalPendencias} pendência(s)
                    <br/><br/>

                    <input className="form-control" disabled value={rotuloSecao} />
                        
                    <br/> 

                    
                    <button type="button" className="btn btn-danger" onClick={() => alteraStatusSecao('E')} style={{ display: 'none'}}>Com pendências</button>&nbsp;
                    <button type="button" className="btn btn-primary" onClick={() => alteraStatusSecao('V')} disabled={ totalPendencias > 0 ? true : false}>Completo</button>&nbsp;
                    <button type="button" className="btn btn-warning" onClick={() => alteraStatusSecao('Z')} disabled={ totalPendencias > 0 ? true : false}>Verificado</button>&nbsp;
                    

                </div>
                <div className="col-md-6">
                    
                    <br/><br/>
                    Última auditoria
                    <br/><br/>

                    <input className="form-control" disabled value={dataHoraUltimaAuditoria && `${dataHoraUltimaAuditoria} - ${nomeUltimaAuditoria}`} />
                    
                    

                </div>

            </div>



        </div>

    )


}

export default StatusValidacaoSecao